"use client";

import { createContext, useContext } from "react";
import type { Review } from "@/components/reviews/ReviewsSection";

// The root layout fetches active reviews once (cached) and AppShell provides
// them here, so the homepage can place ReviewsSection wherever its layout
// wants instead of AppShell appending it after the page.
const ReviewsContext = createContext<Review[]>([]);

export function ReviewsProvider({ reviews, children }: { reviews: Review[]; children: React.ReactNode }) {
  return <ReviewsContext.Provider value={reviews}>{children}</ReviewsContext.Provider>;
}

export function useReviews() {
  return useContext(ReviewsContext);
}
